import PhoneInput from "../../PhoneInput/PhoneInput";
import DatePicker from "../../DatePicker/DatePicker";
import ReactSelect from "../../ReactSelect";
import SearchableSelect from "../../SearchableSelect";
import styles from "./OrdersToolbar.module.css";

export const STATUS_OPTIONS = [
  { value: null, label: "All order statuses" },
  { value: "Pending", label: "Pending" },
  { value: "Confirmed", label: "Confirmed" },
  { value: "Picked", label: "Picked" },
  { value: "Shipped", label: "Shipped" },
  { value: "Delivered", label: "Delivered" },
  { value: "Cancelled", label: "Cancelled" },
  { value: "Returned", label: "Returned" },
  { value: "Verifying Payment", label: "Verifying Payment" },
  { value: "Payment Failed", label: "Payment Failed" },
];

export const PAYMENT_OPTIONS = [
  { value: null, label: "All payment methods" },
  { value: "Bank Transfer", label: "Bank Transfer" },
  { value: "Cash", label: "Cash" },
  { value: "Card", label: "Card" },
  { value: "Card - BNPL", label: "Card - BNPL" },
  { value: "Raast", label: "Raast" },
];

const OrdersFilterBar = ({ values, handlers, categoryOptions }) => (
  <section className={styles.filterBar} aria-label="Order filters">
    <div className={styles.searchField}>
      <label className={styles.fieldLabel} htmlFor="orders-search">Search</label>
      <input
        id="orders-search"
        type="search"
        aria-label="Search orders"
        placeholder="Order ID, customer or phone"
        value={values.search}
        onChange={handlers.onSearchChange}
      />
    </div>
    <div className={styles.phoneField}>
      <label>
        <span className={styles.fieldLabel}>Phone</span>
        <PhoneInput
          placeholder="+92-3XX-XXXXXXX"
          value={values.phone}
          onChange={handlers.onPhoneChange}
        />
      </label>
    </div>
    <div className={styles.dateField}>
      <span className={styles.fieldLabel}>Placed</span>
      <DatePicker
        important
        allLabel="All dates"
        fromDate={values.fromDate}
        toDate={values.toDate}
        setFromDate={handlers.onDateFromChange}
        setToDate={handlers.onDateToChange}
      />
    </div>
    <div className={styles.categoryField}>
      <span className={styles.fieldLabel}>Category</span>
      <ReactSelect
        placeholder="All categories"
        value={values.category}
        searchable
        options={categoryOptions}
        handleChange={handlers.onCategoryChange}
      />
    </div>
    <div className={styles.statusField}>
      <span className={styles.fieldLabel}>Order status</span>
      <SearchableSelect
        placeholder="All order statuses"
        searchable={false}
        value={values.status}
        options={STATUS_OPTIONS}
        handleChange={handlers.onStatusChange}
      />
    </div>
    <div className={styles.paymentField}>
      <span className={styles.fieldLabel}>Payment method</span>
      <SearchableSelect
        placeholder="All payment methods"
        searchable={false}
        value={values.paymentMethod}
        options={PAYMENT_OPTIONS}
        handleChange={handlers.onPaymentMethodChange}
      />
    </div>
    <div className={styles.pageSizeField}>
      <span className={styles.fieldLabel}>Results per page</span>
      <SearchableSelect
        placeholder={`${values.pageSize} per page`}
        value={{ value: values.pageSize, label: `${values.pageSize} per page` }}
        searchable={false}
        options={[
          { value: 10, label: "10 per page" },
          { value: 20, label: "20 per page" },
          { value: 30, label: "30 per page" },
        ]}
        handleChange={handlers.onPageSizeChange}
      />
    </div>
  </section>
);

export default OrdersFilterBar;
